import { Analytics } from '@analytics';
import { SessionStorageKeys } from './constants';

// The embedded PIP keeps its own JWT in localStorage on this same origin
// (pip/frontend/src/embedBridge.js). It outlives a TipDirect logout unless
// something removes it, so signing out of TipDirect removes it too.
const PIP_STORAGE_KEYS = ['pip_token', 'pip_lastActivity', 'pip_userId'];

/**
 * End the TipDirect session and land on the sign-in page.
 *
 * Card 295 needed this from inside the embedded PIP, which is a third caller
 * after the desktop SettingsMenu and the mobile menu; the two existing copies
 * had drifted (only one cleared `locale`), so all three share this now.
 *
 * A failed logout call still navigates: leaving the user staring at the page
 * they asked to leave, with no feedback, is what the old copies did.
 */
export function signOutOfTipDirect() {
  sessionStorage.removeItem(SessionStorageKeys.SkipAllSteps);
  PIP_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
  return fetch('/api/v1/user/logout', { method: 'POST' })
    .then(resp => resp.json())
    .catch(() => null)
    .then(() => {
      localStorage.removeItem('locale');
      Analytics.logoutOfTracking();
      window.location.href = '/signin';
    });
}

export default signOutOfTipDirect;
